module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAA5UlEQVR42mLUXvyegVjAhEPcEIjZiFHMC8RrgbiRGMV9QKwIxKVAbIFPsRcQJ0PZzEC8CIi5sSkWAuI5QMyIJKYKxO3YFE8FYkkszsoBYmdkxaFAHIEjZEA2zQNifpBiCSCeTiCI5YC4nwVIfAViM2IiBaT4MxSTHYM4TdYC4oVoQYYNXAYpvgbEp4A4C4/CX0CcAnNGGRDfwaO4GYgvwBSDQiQeiP9iUXgKFovIHjwGxL1oCr8DcRzMEPTQqAPiK0j8KiC+iSvofkJN+g3EB4B4InrQoYPzQFwOxOuB+D+yBECAAQBPDybJhuWmdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common.png
// module id = Hf3f
// module chunks = 1